import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

interface BurgerMenuProps extends SvgIconProps {}


const BurgerMenuIcon = (props: BurgerMenuProps) => {

    return (
        <SvgIcon {...props}>
            <svg
                width="40"
                height="20"
                viewBox="0 0 40 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="40" height="4" rx="2" fill="black"/>
                <rect y="16" width="40" height="4" rx="2" fill="black"/>
            </svg>
        </SvgIcon>

    )
}

export default BurgerMenuIcon;